import { getReviewerName } from '../utils'

interface ReviewerNameLabelProps {
	firstName: string | null
	lastName: string | null
	email?: string
	isMe?: boolean
}

function ReviewerNameLabel({
	firstName,
	lastName,
	email,
	isMe = false
}: ReviewerNameLabelProps) {
	const { fullName, initials } = getReviewerName({
		firstName,
		lastName,
		email,
		isMe
	})

	return (
		<div className='flex min-w-0 items-center gap-2'>
			<div className='flex size-6 shrink-0 items-center justify-center rounded-full bg-neutral-200 font-medium text-neutral-700 text-xs'>
				{initials}
			</div>
			<span className='truncate text-sm'>{fullName}</span>
		</div>
	)
}
export { ReviewerNameLabel }
